module.exports = {
  messages: {
    CN: {
      'classification.new': '新 建',
      'classification.remind': '温馨提示',
      'classification.remindcontent': '1、拖动的修改将直接影响商品分类页面',
      'classification.serialnumber': '序号',
      'classification.classificationname': '分类名称',
      'classification.goodsnum': '商品数量',
      'classification.updatetime': '更新时间',
      'classification.operation': '操作',
      'classification.edit': '编辑',
      'classification.delete': '删除',
      'classification.newclassification': '新建分类',
      'classification.editclassification': '编辑分类',
      'classification.parentclassification': '父级分类',
      'classification.categoryname': '分类名称',
      'classification.selectclassificationname': '请选择父级分类',
      'classification.classifiedpictures': '分类图片',
      'classification.uploadpictures': '上传图片',
      'classification.suerdelete': '确定要删除吗？',
      'classification.determine': '确定',
      'classification.cancel': '取消',
      'classification.translate': '翻译',
      'classification.chinesetypeface': '简体',
      'classification.categorynameprop': '请输入分类名称',
      'classification.addfirstcategory': '新建一级分类',
      'classification.showflag': '前台显示',
      'classification.showflagprop': '用于PC端是否显示',
      'classification.display': '显示',
      'classification.nodisplay': '不显示',
      "classification.tipsForUploadingPicture": "建议上传1:1比例、分辨率为 {size} 的图片。上传图片大小不能超过 {uploadLimit} MB",
      'classification.allCla': '所有分类'
    },
    JP: {
      'classification.new': '新規作成',
      'classification.remind': 'ヒント',
      'classification.remindcontent': '1、ドラッグ変更は直接商品カテゴリページに反映します',
      'classification.serialnumber': '番号',
      'classification.classificationname': 'カテゴリー名',
      'classification.goodsnum': '商品数量',
      'classification.updatetime': '更新時間',
      'classification.operation': '操作',
      'classification.edit': '編集',
      'classification.delete': '削除',
      'classification.newclassification': '新規カテゴリ',
      'classification.editclassification': 'カテゴリを編集',
      'classification.parentclassification': '親カテゴリ',
      'classification.categoryname': 'カテゴリー名',
      'classification.selectclassificationname': '请选择父级分类',
      'classification.classifiedpictures': 'カテゴリー画像',
      'classification.uploadpictures': '画像をアップロード',
      'classification.suerdelete': '削除してもよろしいですか？',
      'classification.determine': '確定',
      'classification.cancel': 'キャンセル',
      'classification.translate': '翻訳',
      'classification.chinesetypeface': '简体',
      'classification.categorynameprop': 'カテゴリ名を入力してください',
      'classification.addfirstcategory': 'カテゴリー1を新規',
      'classification.showflag': '前台显示',
      'classification.showflagprop': '用于PC端是否显示',
      'classification.display': '表示',
      'classification.nodisplay': '不显示',
      "classification.tipsForUploadingPicture": "1:1の比率、解像度が{size}の画像をアップロードすることをお勧めします。アップロードする画像のサイズは{uploadLimit}MBを超えてはいけません",
      'classification.allCla': '全カテゴリー'
    }
  }
};